import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import CompleteProfile from "../components/CompleteProfile";
import PrivateRoute from "./PrivateRoute";
import { Box, Skeleton } from "@mui/material";
import MainPageSkeleton from "../components/Skeleton";
import ForgotPassword from "../pages/ForgotPassword";

const AppRoutes: React.FC = () => {
    const { user, loadingAuth, requiresProfileCompletion } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loadingAuth) {
            const isSignupPage = location.pathname === "/signup";
            const isForgotPassPage = location.pathname === "/forgot-password";

            if (!user) {
                if (!isSignupPage && !isForgotPassPage) {
                    navigate("/signin", { replace: true });
                }
            } else if (requiresProfileCompletion && !isSignupPage) {
                navigate("/complete-profile", { replace: true });
            }
        }
    }, [user, loadingAuth, requiresProfileCompletion, navigate, location.pathname]);

    if (loadingAuth) {
        if (location.pathname.startsWith("/signin") || location.pathname.startsWith("/signup")) {
            return (
                <Box sx={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
                    <Skeleton variant="rectangular" width={300} height={150} />
                </Box>
            );
        }
        return <MainPageSkeleton />;
    }

    return (
        <Routes>
            {!user ? (
                <>
                    <Route path="/signin" element={<SignInPage />} />
                    <Route path="/signup" element={<SignUpPage />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="*" element={<Navigate to="/signin" replace />} />
                </>
            ) : requiresProfileCompletion ? (
                <Route path="/complete-profile" element={<CompleteProfile />} />
            ) : (
                <Route path="/*" element={<PrivateRoute />} />
            )}
        </Routes>
    );
};

export default AppRoutes;
